// extracted by mini-css-extract-plugin
export var bottomContainer = "eleusis-module--bottomContainer--I9Gwb";
export var canvas = "eleusis-module--canvas--6MBSr";
export var connectingText = "eleusis-module--connectingText--aJRqx";
export var loadingText = "eleusis-module--loadingText--f3MdA";